import { render, staticRenderFns } from "./PanduanApp.vue?vue&type=template&id=289780e7&scoped=true&"
import script from "./PanduanApp.vue?vue&type=script&lang=js&"
export * from "./PanduanApp.vue?vue&type=script&lang=js&"
import style0 from "./PanduanApp.vue?vue&type=style&index=0&id=289780e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289780e7",
  null
  
)

export default component.exports